export const money = (n) => (typeof n === "number" ? `$${n.toLocaleString()}` : "—");


export const clampWords = (str = "", max = 14) => {
    const words = str.split(/\s+/);
    if (words.length <= max) return str;
    return words.slice(0, max).join(" ") + "…";
};


export const getImagesForItem = (item = {}) => {
    const images = Array.isArray(item.images) && item.images.length > 0
        ? item.images
        : Array.isArray(item.photos) && item.photos.length > 0
            ? item.photos
            : [
                `https://cdn.imagin.studio/getImage?customer=img&make=${encodeURIComponent(
                    item.make || item.vehicle_make || ""
                )}&modelFamily=${encodeURIComponent(item.model || item.title || "")}&modelYear=${item.year || ""}&angle=front`,
            ];
    return images.filter(Boolean);
};


export const listedDaysAgo = (dateLike) => {
    if (!dateLike) return "";
    const days = Math.floor((Date.now() - new Date(dateLike).getTime()) / (1000 * 60 * 60 * 24));
    return `Listed ${days} day${days !== 1 ? "s" : ""} ago`;
};